import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Toaster } from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';
import reportWebVitals from './reportWebVitals';

// Google OAuth client ID — set REACT_APP_GOOGLE_CLIENT_ID in the build env.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#333',
          color: '#fff',
          fontSize: '16px',
          borderRadius: '12px',
          padding: '16px 20px',
        },
        success: {
          icon: '✅',
          style: { background: '#10b981' },
        },
        error: {
          icon: '❌',
          style: { background: '#ef4444' },
        },
        loading: {
          style: { background: '#6366f1' },
        },
      }}
    />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
reportWebVitals();